import { useEffect, useState } from "react";
import ChatRightAside from "./ChatRightAside";
import { chatUserPath } from "../../../routes/routes";
import { useNavigate } from "react-router-dom";

const toChatState = (c) => {
  const idUsuario = c.idUsuario ?? c.id ?? c.idUsuarioOrigen;
  const display = (c.nombre ?? c.name ?? c.nombres ?? "").toString().trim();
  const [nombres, ...rest] = display.split(" ");
  return {
    idChat: c.idChat ?? c.IdChat ?? null,
    idUsuario,
    nombre: display,
    nombres,
    apellidos: rest.join(" ") || c.apellidos || "",
    profPic: c.fotoPerfilUrl ?? c.avatar ?? null,
    mensaje: c.mensaje ?? c.lastMessage ?? "",
    lastMessage: c.lastMessage ?? c.mensaje ?? "",
    idMensaje:
      c.idMensaje ??
      c.idMessage ??
      c.lastMessageId ??
      c.messageId ??
      c.idUltimoMensaje ??
      null,
    lastMessageId:
      c.lastMessageId ??
      c.idMensaje ??
      c.idMessage ??
      c.messageId ??
      c.idUltimoMensaje ??
      null,
    idNacionalidad: c.idNacionalidad,
    nickName: c.nickName,
    estatus: c.estatus,
  };
};

const ChatSiderHome = ({
  contacts = [],
  counters = {},
  loading,
  isRefreshing,
  activeFilter = "all",
  onFilterChange,
  onArchiveChat,
  onDeleteChat,
}) => {
  const navigate = useNavigate();
  const [activeContactId, setActiveContactId] = useState(null);

  useEffect(() => {
    try {
      const lastChatUser = JSON.parse(localStorage.getItem("lastChatUser") || "{}");
      const lastChatUserId =
        lastChatUser?.idUsuario ?? lastChatUser?.id ?? lastChatUser?.idUsuarioOrigen ?? null;
      setActiveContactId(lastChatUserId ? String(lastChatUserId) : null);
    } catch (error) {
      console.error("[Messages][HomeSidebar] Could not restore active chat", error);
      setActiveContactId(null);
    }
  }, []);

  const handleClick = (contact) => {
    const safeState = toChatState(contact);
    const selectedContactId =
      contact.id ?? contact.idUsuario ?? contact.idUsuarioOrigen ?? null;

    setActiveContactId(selectedContactId ? String(selectedContactId) : null);
    localStorage.setItem("lastChatUser", JSON.stringify(safeState));
    navigate(chatUserPath, { state: safeState });
  };

  return (
    <ChatRightAside
      contacts={contacts}
      counters={counters}
      activeContactId={activeContactId}
      loading={loading}
      isRefreshing={isRefreshing}
      activeFilter={activeFilter}
      onFilterChange={onFilterChange}
      onSelectContact={handleClick}
      onStartNewMessage={() => {}}
      onArchiveChat={onArchiveChat}
      onDeleteChat={onDeleteChat}
      variant="compact"
    />
  );
};

export default ChatSiderHome;
